<template>
	<div class="packing-slips" id="packing-slips">
		<div class="packing-slip" v-for="(order, index) in orders" :key="index">
			<div class="row">
				<div :class="colClass">
					<div class="row">
						<div class="col-7">
							<div class="packing-slip-recipient">
								<div class="mb-1"><b>Kepada:</b></div>
								<div class="recipient__name text-uppercase mb-1">{{ order.customer_data.name }}</div>
								<div class="recipient__address" v-if="order.customer_data.address">{{ order.customer_data.address }}</div>
								<div>
									<span class="recipient__district" v-if="order.customer_data.district">{{ order.customer_data.district }}, </span>
									<span class="recipient__city" v-if="order.customer_data.city">{{ order.customer_data.city }}</span>
								</div>
								<!-- <div class="recipient__email" v-if="order.customer_data.email">{{ order.customer_data.email }}</div> -->
								<div class="recipient__phone mt-1" v-if="order.customer_data.phone">Telp: {{ order.customer_data.phone }}</div>
								<!-- <div class="recipient__notes" v-if="order.customer_data.notes">Notes: {{ order.customer_data.notes }}</div> -->
							</div>
						</div>
						<div class="col-5">
							<div class="packing-slip-order mb-1"><b>Order #{{ order.order_id }} <span class="packing-slip-order-date">{{ moment(order.created_at).format('DD-MM-YYYY') }}</span></b></div>
							<div class="packing-slip-product">
								<div class="packing-slip-product__name">{{ order.product_name }} <span v-if="order.customer_data.quantity">(x{{order.customer_data.quantity}})</span></div>
								<small class="packing-slip-variation" v-if="order.customer_data.variation">{{ order.customer_data.variation }}</small>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-7">
							<div class="packing-slip-sender">
								<div class="mb-1"><b>Pengirim:</b></div>
								<div class="sender__name text-uppercase mb-1">{{ store.name }}</div>
								<div class="sender__website" v-if="store.website">{{ store.website }}</div>
								<div class="sender__phone" v-if="store.phone">{{ store.phone }}</div>
							</div>
						</div>
						<div class="col-5">
							<div class="packing-slip-shipment" v-if="order.shipping.courier !== ''">{{ order.shipping.courier }} - {{ order.shipping.service }}</div>
						</div>
					</div>
				</div>
				<div class="col-3 p-0" v-if="fragile">
					<div class="packing-slip-fragile text-center">
						<img src="/images/fragile-small.png" alt="Fragile" class="mb-2">
						<h3><b>FRAGILE</b></h3>
						<h5><b>JANGAN DIBANTING!!</b></h5>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line
import moment from 'moment';

export default {
	name: 'packingSlips',
	props: {
		orders: {
			type: Array,
			default: () => [],
		},
		store: {
			type: Object,
		},
		fragile: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
		colClass() {
			return this.fragile ? 'col-9' : 'col-12';
		},
	},
};
</script>

<style lang="scss">
.packing-slip {
	padding: 1em 1.5em;
	height: 320px;
	color: #333;
	font-size: .95em;
	border: 1px solid #ddd;
}

.packing-slip-recipient {
	min-height: 150px;
}

.packing-slip-sender {
	min-height: 97px;
}

.packing-slip-shipment {
	display: inline-block;
	padding: .5em 1em;
	font-weight: bold;
	border: 2px solid #333;
	text-transform: uppercase;
}

.packing-slip-fragile {
	margin-top: 25%;
	margin-right: 2em;
}
</style>
